import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: 'rgba(0, 0, 0, 0.6)'
  },
  modalMain: {
    position: "fixed",
    background: theme.palette.background.default,
    width: "50%",
    height: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-40%, -50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  modalCloseIcon: {
    alignSelf: "flex-end"
  },
  displayBlock: {
    display: 'block',
    zIndex: 1
  },
  displayNone: {
    display: 'none'
  }  
}));

const Modal = ({ handleClose, show, children }: any) => {
  const classes = useStyles();
  const showHideClassName = show ? [classes.modal, classes.displayBlock].join(' ') : [classes.modal, classes.displayNone].join(' ');

  return (
    <div className={showHideClassName}>
      <section className={classes.modalMain}>
        <div className={classes.modalCloseIcon}>
          <AiOutlineCloseCircle onClick={handleClose} size={35} color={"black"} />
        </div>
        {children}
      </section>
    </div>
  );
};

export default Modal;